import React from 'react'

import {
  AlignItems,
  Box,
  Display,
  FlexDirection,
  JustifyContent,
  Text,
  TextAlign,
} from '@gousto-internal/citrus-react'

import { onSpaceOrEnter } from 'utils/accessibility'

import { Bad, Good, Great, Ok, VeryBad } from './Sentiment'

export type SelectedSentiment = {
  score: number
  value: string
}

type SentimentOption = {
  component: React.ElementType
  label: string
  score: number
  value: string
}

type SentimentOptionsProps = {
  onSelect: ({ score, value }: SelectedSentiment) => void
  selected?: string
}

const sentimentOptions: SentimentOption[] = [
  { component: VeryBad, label: 'Very bad', score: 1, value: 'very_bad' },
  { component: Bad, label: 'Bad', score: 2, value: 'bad' },
  { component: Ok, label: 'Ok', score: 3, value: 'ok' },
  { component: Good, label: 'Good', score: 4, value: 'good' },
  { component: Great, label: 'Great', score: 5, value: 'great' },
]

export const SentimentOptions = ({ onSelect, selected }: SentimentOptionsProps) => (
  <Box
    alignItems={AlignItems.Baseline}
    data-testid="sentiment-options"
    display={Display.Flex}
    flexDirection={FlexDirection.Row}
    justifyContent={JustifyContent.SpaceBetween}
    width="100%"
  >
    {sentimentOptions.map(({ component, label, score, value }) => (
      <Box
        key={value}
        alignItems={AlignItems.Center}
        display={Display.Flex}
        flexDirection={FlexDirection.Column}
        height="80px"
        justifyContent={JustifyContent.Center}
        onClick={() => onSelect({ score, value })}
        onKeyDown={onSpaceOrEnter(() => onSelect({ score, value }))}
        role="button"
        tabIndex={0}
        width="80px"
        style={{ cursor: 'pointer', opacity: selected && selected !== value ? 0.2 : 1 }}
      >
        <Box flexShrink={0}>{React.createElement(component)}</Box>
        <Text size={2} textAlign={TextAlign.Center}>
          {label}
        </Text>
      </Box>
    ))}
  </Box>
)
